module.exports = __webpack_public_path__ + "img/featured-article-placeholder.0e72fdf6.svg";